import { useFlightPLS } from '@pages/FlightSearchResult/contexts/FlightPerLegSearchContext/FlightPerLegSearchContext';
import {
  getSelectedSortTypesForPerLegSearchFromParam,
  getSelectedSortOderForPerLegSearchFromParam,
} from '@pages/FlightSearchResult/flightPerLegSearchSort';
import { useCallback } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';

import { getFlightSortType } from '@helpers/flightSort';

import useFlightSearchResultsDatadog from '@hooks/useFlightSearchResultsDatadog';

import { FlightSortType } from '@wegoTypes/flights/flightSortType';
import { SortOrder } from '@wegoTypes/sortOrder';

const useFlightSearchSort = () => {
  const [searchParams] = useSearchParams();

  const navigate = useNavigate();

  const { recordChangeSortAction } = useFlightSearchResultsDatadog();

  const { isPerLegSearch, isPLSDepartLegSelection } = useFlightPLS();

  const activeLeg = !isPLSDepartLegSelection ? 1 : 0;

  const sortTypeSearchParam = searchParams.get('sort');
  const sortOrderSearchParam = searchParams.get('order');

  const sortType: FlightSortType = (() => {
    if (sortTypeSearchParam) {
      const sortParam = sortTypeSearchParam.split(':')[isPerLegSearch ? activeLeg : 0] || 'score';
      return getFlightSortType(sortParam);
    }
    return 'score';
  })();

  const sortOrder: SortOrder = (() => {
    if (!!sortOrderSearchParam) {
      const sortOrderParam =
        sortOrderSearchParam.split(':')[isPerLegSearch ? activeLeg : 0] || 'desc';

      return sortOrderParam.toLowerCase() === 'asc' ? 'asc' : 'desc';
    }
    return 'desc';
  })();

  const changeSort = useCallback(
    (flightSortType: FlightSortType, sortOrder: SortOrder) => {
      recordChangeSortAction();

      if (isPerLegSearch) {
        const selectedTripSortTypesArray = getSelectedSortTypesForPerLegSearchFromParam(
          sortTypeSearchParam || '',
          false,
        );

        const newSelectedSortArray = selectedTripSortTypesArray.map((item, index) => {
          if (index === activeLeg) {
            return flightSortType;
          }
          return item;
        });

        searchParams.set('sort', newSelectedSortArray.join(':'));

        const selectedSortOrderArray = getSelectedSortOderForPerLegSearchFromParam(
          sortOrderSearchParam || '',
          false,
        );

        const newSelectedSortOrderArray = selectedSortOrderArray.map((item, index) => {
          if (index === activeLeg) {
            return sortOrder;
          }
          return item;
        });

        searchParams.set('order', newSelectedSortOrderArray.join(':'));
      } else {
        searchParams.set('sort', flightSortType);

        searchParams.set('order', sortOrder);
      }

      navigate(`?${searchParams.toString()}`, { replace: true });
    },
    [
      activeLeg,
      searchParams,
      navigate,
      recordChangeSortAction,
      isPerLegSearch,
      sortTypeSearchParam,
      sortOrderSearchParam,
    ],
  );

  return {
    sortType,
    sortOrder,
    changeSort,
  };
};

export default useFlightSearchSort;
